const STATUS_MAP = {
  connected:    ['LIVE', 'badge-success'],
  connecting:   ['CONNECTING', 'badge-warning'],
  disconnected: ['OFFLINE', 'badge-error'],
  error:        ['ERROR', 'badge-error'],
  loading:      ['LOADING', 'badge-ghost'],
  'no-config':  ['NO CONFIG', 'badge-error'],
};

export default function StatusBadge({ status }) {
  const [text, cls] = STATUS_MAP[status] || ['UNKNOWN', 'badge-ghost'];
  return <span className={`badge badge-sm ${cls}`}>{text}</span>;
}
